module.exports = __webpack_public_path__ + "static/media/princes-dress.d4493484.jpg";